<script setup lang="ts">
import { Loader2Icon } from 'lucide-vue-next'
import { cn } from '@/lib/utils'
</script>

<template>
  <Loader2Icon :class="cn('animate-spin text-foreground', $attrs.class)" />
</template>
